import { Component } from 'react'
import PropTypes from 'prop-types'
import Loading from 'components/center-loading'
import { Row, Col } from 'react-flexbox-grid'
import { SelectBox } from "components/uikit-adapter/index"
import intl from 'react-intl-universal';

import StyledFilter from './StyledFilter'
import Button from 'components/button'

class FiltroGeralMaterial extends Component {
  constructor() {
    super()

    this.state = {
      isFetching: false,
      IdFornecedor: null,
      IdFamiliaRotuladaCentro: ''
    }

    this.changeValue = this.changeValue.bind(this)
    this.handleCloseSearch = this.handleCloseSearch.bind(this)
    this.handleCleanClick = this.handleCleanClick.bind(this)
  }

  componentDidMount() {
    const { initialData } = this.props;
    this.setState({
      IdFornecedor: initialData.IdFornecedor,
      IdFamiliaRotuladaCentro: initialData.IdFamiliaRotuladaCentro,
    });
  }

  changeValue = (name, value) => {
    this.setState({
      [name]: value,
    })
  }

  handleCleanClick() {
    const params = {
      IdFornecedor: null,
      IdFamiliaRotuladaCentro: this.state.IdFamiliaRotuladaCentro
    }
    this.setState(params, () => this.props.handleClose(params))
  }

  handleCloseSearch() {
    const params = {
      IdFornecedor: this.state.IdFornecedor,
      IdFamiliaRotuladaCentro: this.state.IdFamiliaRotuladaCentro
    }
    this.props.handleClose(params)
  }

  render() {
    const {
      IdFornecedor,
      isFetching
    } = this.state
    const { filterOptions } = this.props;

    return (
      <StyledFilter>
        <Loading isLoading={isFetching} />
        <div className="filter-container">
          <div className="sideFilterFields">
            <Row>
              <Col xs={12} lg={12} md={12}>
                <SelectBox
                  name='supplier'
                  label={intl.get('commons.supplier')}
                  placeholder={intl.get('commons.supplier')}
                  valueKey="IdFornecedor"
                  labelKey="Descricao"
                  value={IdFornecedor}
                  onChange={value => this.changeValue('IdFornecedor', value === null ? null : value.IdFornecedor)}
                  options={filterOptions.suppliers}
                  searchable
                  openOnFocus
                  clearable
                />
              </Col>
            </Row>
          </div>
          <Row className="footerFilterContainer no-margin">
            <Col xs={12}>
              <Row>
                <Col xs={12} lg={12} md={12}>
                  <hr className="filter-divisor" />
                </Col>
              </Row>
              <Row>
                <Col xs={6} lg={6} md={6}>
                  <Button buttonType="primary" onClick={this.handleCloseSearch} value={intl.get('filters.search')} />
                </Col>
                <Col xs={6} lg={6} md={6}>
                  <Button onClick={this.handleCleanClick} value={intl.get('filters.cleanSearch')} />
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </StyledFilter>
    )
  }
}

FiltroGeralMaterial.propTypes = {
  initialData: PropTypes.object,
  transitionTime: PropTypes.number,
  handleClose: PropTypes.func,
  filterOptions: PropTypes.shape({
    suppliers: PropTypes.array
  })
}

FiltroGeralMaterial.defaultProps = {
  transitionTime: 500,
  initialData: {}
}

export default FiltroGeralMaterial
